import React, { FC, ReactNode, RefObject, useState } from 'react';
import { styled } from 'linaria/react';
import { useBreakpoint, useOutsideClick } from '@shared/lib/react';
import { BottomSheetProps } from '@shared/ui/molecules';
import UserAvatar from './UserAvatar';
export type UserAvatarMenuProps = Pick<BottomSheetProps, 'open' | 'onClose'>;
interface UserAvatarButtonWithMenuProps {
  menu: (props: UserAvatarMenuProps) => ReactNode;
}
const UserAvatarButtonWithMenu: FC<UserAvatarButtonWithMenuProps> = ({
  menu
}) => {
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const {
    isMobile
  } = useBreakpoint();
  const {
    outsideClickRef
  } = useOutsideClick(() => handleCloseMenu(), undefined, isMobile);
  const handleOpenMenu = () => {
    setIsVisible(true);
  };
  const handleCloseMenu = () => {
    setIsVisible(false);
  };
  return <UserAvatarButtonWithMenuWrapper ref={outsideClickRef as RefObject<HTMLDivElement>}>
      <UserIconWrapper onClick={handleOpenMenu}>
        <UserAvatar />
      </UserIconWrapper>
      {menu({
      open: isVisible,
      onClose: handleCloseMenu
    })}
    </UserAvatarButtonWithMenuWrapper>;
};
export default UserAvatarButtonWithMenu;
const UserAvatarButtonWithMenuWrapper = /*#__PURE__*/styled('div')({
  name: "UserAvatarButtonWithMenuWrapper",
  class: "uf8c8sz",
  propsAsIs: false
});
const UserIconWrapper = /*#__PURE__*/styled('button')({
  name: "UserIconWrapper",
  class: "u1unkhl",
  propsAsIs: false
});

require("./UserAvatarButtonWithMenu.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./UserAvatarButtonWithMenu.tsx");